var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_894",
    "data-name": "Gruppe 894",
    transform: "translate(-11020 13103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_pin_circle_FILL1_wght400_GRAD0_opsz48",
    d: "M24,44A66.487,66.487,0,0,1,11.975,31.275Q8,25.4,8,20.4q0-7.5,4.825-11.95a16.257,16.257,0,0,1,22.35,0Q40,12.9,40,20.4q0,5-3.975,10.875A66.487,66.487,0,0,1,24,44Z",
    transform: "translate(11012 -13107)",
    fill: "#005851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "person_pin_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M24.05,29.5A9.172,9.172,0,0,0,28.7,28.3a9.448,9.448,0,0,0,3.346-3.2,12.428,12.428,0,0,0-3.723-1.95,14.395,14.395,0,0,0-8.553,0A12.428,12.428,0,0,0,16.05,25.1,9.448,9.448,0,0,0,19.4,28.3,9.172,9.172,0,0,0,24.05,29.5Zm0-10a3.4,3.4,0,0,0,2.491-1.025,3.485,3.485,0,0,0,0-4.95,3.538,3.538,0,0,0-4.981,0,3.485,3.485,0,0,0,0,4.95A3.4,3.4,0,0,0,24.05,19.5ZM24.05,20.4Z",
    transform: "translate(11011.95 -13107.5)",
    fill: "#005851",
    stroke: "#d9e868",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.eb9c4669066b514e86e8f539031fac79.svg";
export { ForwardRef as ReactComponent };